module.exports = __webpack_public_path__ + "img/main-top-header.06f62f09.png";